import { render, staticRenderFns } from "./OscillationSIM.vue?vue&type=template&id=2195aef0&"
import script from "./OscillationSIM.vue?vue&type=script&lang=js&"
export * from "./OscillationSIM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports